<template lang="html">

  <section class="btn-consulter">
    <div class="container-fluid">
      <div class="checkussd text-center section" style="padding-top:0;">
          <router-link to="/ussd" class="btn btn-darkblue btn-chevron" role="button">
              <i class="fa fa-mobile-phone" aria-hidden="true"></i>
              Consultez la liste des billets par USSD</router-link>
      </div>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'btn-consulter',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style>
</style>

